import PropTypes from 'prop-types';
import { camelCase } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageActionBar from 'components/PageActionBar';
import UploadsTable from 'components/UploadsTable';
import UploadDialog from 'components/UploadDialog';
import { FontIcon } from 'react-toolbox';
import contentAreaStyles from 'styles/contentArea';
import styles from './styles.scss';
import { getLocalDate, getMinLocalDate } from '../../../utils/dateUtils';
import Paginate from 'components/Pagination';
import { uploadFile, toggleDialog, setErrorMessage, getUploadsList } from 'actionCreators';
import { getRole, getUploadListData, getUploadHasNextPage, getUploadListLoading,
         getUploadError, getUploadLoading, getUploadDialogStatus, getUploadIsProcessing,
         getUploadPage, getUploadTotalCount } from '../../../reducers';

class UploadsManager extends Component {
  constructor(props) {
    super(props);
    this.addAction = this.addAction.bind(this);
    this.handleDialogToggle = this.handleDialogToggle.bind(this);
    this.handleDialogSubmit = this.handleDialogSubmit.bind(this);
    this.setErrorMessage = this.setErrorMessage.bind(this);
  }

  componentWillMount = () => this.props.getUploadsList(this.props.uploadType, 1);

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      clearInterval(this.polling);
      if (nextProps.uploadIsProcessing) this.startPoll();
    }
  }

  componentWillUnmount = () => clearInterval(this.polling);

  setErrorMessage = error => this.props.setErrorMessage(error, this.props.uploadType);

  getUploadListByPage = page => this.props.getUploadsList(this.props.uploadType, page);

  startPoll = () => {
    this.polling = setInterval(() => this.props.getUploadsList(this.props.uploadType), 7000);
  }

  handleDialogToggle = () =>
    this.props.toggleDialog(!this.props.dialogActive, this.props.uploadType);

  handleDialogSubmit = formData => this.props.uploadFile(formData, this.props.uploadType)
    .then(() => this.props.getUploadsList(this.props.uploadType));

  addAction = () => this.handleDialogToggle();

  render = () => {
    const { data, uploadType, title, loading, needsMore,
            role, page, totalCount, user } = this.props;
    const uploads = data.map(upload => ({
      id: upload.id,
      active: upload.active,
      uploadName: (<a href={upload.expiring_download_url} className={styles.uploadLink}>
        <FontIcon value="insert_drive_file" className={styles.centerFont} />
      </a>),
      uploadedBy: upload.user.name,
      uploadedOn: getLocalDate(upload.created_at),
      uploadedOnMobile: getMinLocalDate(upload.created_at),
      statusText: upload.status,
      summary: upload.summary,
    }));
    const resource = uploadType.slice(0, -1);
    return (<div>
      <PageActionBar
        resource={resource}
        role={role}
        title={`${title} Uploads`}
        addAction={this.addAction}
        showFiltersBtn={false}
        user={user}
        showAdd
      />
      <UploadDialog
        active={this.props.dialogActive}
        title={`Upload ${title}`}
        formDataKey={`${resource}[asset]`}
        handleToggle={this.handleDialogToggle}
        handleSubmit={this.handleDialogSubmit}
        errors={this.props.uploadError}
        setErrorMessage={this.setErrorMessage}
        fileLoading={this.props.fileLoading}
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        <UploadsTable
          downloadColumnName="Download"
          role={role}
          data={uploads}
          needsMore={needsMore}
          loading={loading}
          handleInfiniteLoad={this.handleInfiniteLoad}
        />
        <br />
        <Paginate
          currentPage={page}
          totalCount={totalCount}
          getListPage={pageNum => this.getUploadListByPage(pageNum)}
        />
      </div>
    </div>);
  }
}

UploadsManager.propTypes = {
  role: PropTypes.string,
  uploadError: PropTypes.object,
  fileLoading: PropTypes.bool,
  dialogActive: PropTypes.bool,
  uploadFile: PropTypes.func,
  toggleDialog: PropTypes.func,
  setErrorMessage: PropTypes.func,
  getUploadListData: PropTypes.func,
  data: PropTypes.array,
  uploadIsProcessing: PropTypes.bool,
  uploadType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  getUploadsList: PropTypes.func,
  needsMore: PropTypes.bool,
  loading: PropTypes.bool,
  page: PropTypes.number,
  totalCount: PropTypes.number,
  user: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const uploadKey = camelCase(ownProps.uploadType);
  const uploadState = state[uploadKey];
  return {
    role: getRole(state),
    needsMore: getUploadHasNextPage(uploadState),
    loading: getUploadListLoading(uploadState),
    uploadError: getUploadError(uploadState) || {},
    fileLoading: getUploadLoading(uploadState),
    dialogActive: getUploadDialogStatus(uploadState),
    data: getUploadListData(uploadState) || [],
    uploadIsProcessing: getUploadIsProcessing(uploadState),
    page: getUploadPage(uploadState),
    totalCount: getUploadTotalCount(uploadState),
    user: state.user,
  };
};

export default connect(mapStateToProps, {
  uploadFile, toggleDialog, setErrorMessage, getUploadsList,
})(UploadsManager);



// WEBPACK FOOTER //
// ./client/app/shared/components/UploadManager/index.jsx